import previewImage from "../../../assets/blog/practicedo.png"
import { Post } from "../../../types/postTypes"

export const PracticeDoClosing: Post = {
  metadata: {
    id: 21,
    title:
      "Practice.do Is Closing — and It’s a Wake-Up Call for the Coaching Industry",
    author: "Zoee",
    date: "October 16, 2025",
    urlSlug:
      "practice-do-is-closing-and-it-s-a-wake-up-call-for-the-coaching-industry",
    description:
      "If Practice.do’s shutdown shook your business, you’re not alone. Here’s how Zoee helps coaches rebuild stronger—with tools that truly understand your work.",
    previewImg: previewImage,
    tags: ["Coach", "Business", "Entrepreneur"],
  },
  content: [], 
}
